// extracted by mini-css-extract-plugin
export default {"root":"home_root__IYKpc"};